// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%2394a3b8%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Structure Form - Theme-Aware */

.structure-form {
  background: var(--cfn-popup-bg);
  border-radius: 12px;
  box-shadow: var(--cfn-popup-shadow);
  border: 1px solid var(--cfn-border);
  min-width: 340px;
  max-width: 420px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--cfn-text-primary);
}

/* Header */
.structure-form__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-header-bg);
  border-left: 3px solid var(--cfn-accent-primary);
  border-radius: 12px 12px 0 0;
}

.structure-form__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--cfn-btn-primary-bg);
  box-shadow: var(--cfn-shadow-md);
  flex-shrink: 0;
}

.structure-form__icon i {
  font-size: 18px;
  color: #ffffff;
}

.structure-form__title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--cfn-text-primary);
}

.structure-form__subtitle {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: var(--cfn-text-muted);
}

/* Form */
.structure-form__form {
  display: flex;
  flex-direction: column;
}

.structure-form__fields {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);
}

.structure-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.structure-form__label {
  font-size: 13px;
  font-weight: 500;
  color: var(--cfn-text-secondary);
}

.structure-form__required {
  color: var(--cfn-danger);
}

/* Inputs */
.structure-form__input,
.structure-form__textarea,
.structure-form__select {
  width: 100%;
  padding: 10px 12px;
  background: var(--cfn-input-bg);
  border: 1px solid var(--cfn-input-border);
  border-radius: 8px;
  color: var(--cfn-input-text);
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s ease;
}

.structure-form__input:focus,
.structure-form__textarea:focus,
.structure-form__select:focus {
  outline: none;
  border-color: var(--cfn-input-focus-border);
  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);
}

.structure-form__input::-moz-placeholder, .structure-form__textarea::-moz-placeholder {
  color: var(--cfn-input-placeholder);
}

.structure-form__input::placeholder,
.structure-form__textarea::placeholder {
  color: var(--cfn-input-placeholder);
}

.structure-form__textarea {
  resize: vertical;
  min-height: 80px;
}

.structure-form__select {
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

.structure-form__select option {
  background: var(--cfn-bg-secondary);
  color: var(--cfn-text-primary);
}

.structure-form__checkbox {
  width: 20px;
  height: 20px;
  accent-color: var(--cfn-accent-primary);
}

/* Errors */
.structure-form__error {
  font-size: 12px;
  color: var(--cfn-danger-text);
  margin-top: 4px;
}

/* Guidance under a field, e.g. the accepted CFN ID forms */
.structure-form__hint-text {
  font-size: 12px;
  opacity: 0.7;
  margin-top: 4px;
}

.structure-form__error--global {
  margin: 0 16px 12px;
  padding: 12px;
  background: var(--cfn-danger-muted);
  border: 1px solid var(--cfn-btn-danger-border);
  border-radius: 8px;
}

/* Footer */
.structure-form__footer {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-footer-bg);
  border-radius: 0 0 12px 12px;
}

.structure-form__footer-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid var(--cfn-border);
  border-radius: 8px;
  background: var(--cfn-btn-secondary-bg);
  color: var(--cfn-text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.structure-form__footer-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.structure-form__footer-btn:not(:disabled):hover {
  background: var(--cfn-btn-secondary-hover-bg);
}

.structure-form__footer-btn--primary {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-btn-primary-border);
  flex: 1.5;
}

.structure-form__footer-btn--primary:not(:disabled):hover {
  background: var(--cfn-btn-primary-bg);
  color: var(--cfn-btn-primary-text);
  box-shadow: 0 4px 12px var(--cfn-focus-ring);
}

.structure-form__footer-btn--danger {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-btn-danger-border);
  color: var(--cfn-danger-text);
}

.structure-form__footer-btn--danger:not(:disabled):hover {
  background: var(--cfn-btn-danger-hover-bg);
}

/* Spinner */
@keyframes spin {
  to { transform: rotate(360deg); }
}

.fa-spinner.fa-spin {
  animation: spin 1s linear infinite;
}

/* Served-premises tick list in the premises box dialog */
.structure-form__checkbox-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 0;
  font-weight: 400;
  cursor: pointer;
}

.structure-form__checkbox-row input {
  margin-top: 3px;
  flex: 0 0 auto;
}

.structure-form__hint {
  margin-left: 8px;
  font-weight: 400;
  opacity: 0.7;
}

/* Leaflet popup wrapper */
.leaflet-popup-content-wrapper.structure-form-wrapper {
  background: transparent;
  padding: 0;
  box-shadow: none;
  border-radius: 12px;
}

.leaflet-popup-content-wrapper.structure-form-wrapper .leaflet-popup-content {
  margin: 0;
  width: auto !important;
}

.leaflet-popup-tip-container.structure-form-tip {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/structure-form.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,8EAA8E;EAC9E,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;;;EAGE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EAEE,mCAAmC;AACrC;;AAHA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,6CAA6C;EAC7C,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,YAAY;AACZ;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Structure Form - Theme-Aware */\n\n.structure-form {\n  background: var(--cfn-popup-bg);\n  border-radius: 12px;\n  box-shadow: var(--cfn-popup-shadow);\n  border: 1px solid var(--cfn-border);\n  min-width: 340px;\n  max-width: 420px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--cfn-text-primary);\n}\n\n/* Header */\n.structure-form__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-header-bg);\n  border-left: 3px solid var(--cfn-accent-primary);\n  border-radius: 12px 12px 0 0;\n}\n\n.structure-form__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--cfn-btn-primary-bg);\n  box-shadow: var(--cfn-shadow-md);\n  flex-shrink: 0;\n}\n\n.structure-form__icon i {\n  font-size: 18px;\n  color: #ffffff;\n}\n\n.structure-form__title h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--cfn-text-primary);\n}\n\n.structure-form__subtitle {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: var(--cfn-text-muted);\n}\n\n/* Form */\n.structure-form__form {\n  display: flex;\n  flex-direction: column;\n}\n\n.structure-form__fields {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: 400px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);\n}\n\n.structure-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.structure-form__label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--cfn-text-secondary);\n}\n\n.structure-form__required {\n  color: var(--cfn-danger);\n}\n\n/* Inputs */\n.structure-form__input,\n.structure-form__textarea,\n.structure-form__select {\n  width: 100%;\n  padding: 10px 12px;\n  background: var(--cfn-input-bg);\n  border: 1px solid var(--cfn-input-border);\n  border-radius: 8px;\n  color: var(--cfn-input-text);\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.2s ease;\n}\n\n.structure-form__input:focus,\n.structure-form__textarea:focus,\n.structure-form__select:focus {\n  outline: none;\n  border-color: var(--cfn-input-focus-border);\n  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);\n}\n\n.structure-form__input::placeholder,\n.structure-form__textarea::placeholder {\n  color: var(--cfn-input-placeholder);\n}\n\n.structure-form__textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.structure-form__select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n}\n\n.structure-form__select option {\n  background: var(--cfn-bg-secondary);\n  color: var(--cfn-text-primary);\n}\n\n.structure-form__checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: var(--cfn-accent-primary);\n}\n\n/* Errors */\n.structure-form__error {\n  font-size: 12px;\n  color: var(--cfn-danger-text);\n  margin-top: 4px;\n}\n\n/* Guidance under a field, e.g. the accepted CFN ID forms */\n.structure-form__hint-text {\n  font-size: 12px;\n  opacity: 0.7;\n  margin-top: 4px;\n}\n\n.structure-form__error--global {\n  margin: 0 16px 12px;\n  padding: 12px;\n  background: var(--cfn-danger-muted);\n  border: 1px solid var(--cfn-btn-danger-border);\n  border-radius: 8px;\n}\n\n/* Footer */\n.structure-form__footer {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  border-top: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-footer-bg);\n  border-radius: 0 0 12px 12px;\n}\n\n.structure-form__footer-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 1px solid var(--cfn-border);\n  border-radius: 8px;\n  background: var(--cfn-btn-secondary-bg);\n  color: var(--cfn-text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.structure-form__footer-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.structure-form__footer-btn:not(:disabled):hover {\n  background: var(--cfn-btn-secondary-hover-bg);\n}\n\n.structure-form__footer-btn--primary {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-btn-primary-border);\n  flex: 1.5;\n}\n\n.structure-form__footer-btn--primary:not(:disabled):hover {\n  background: var(--cfn-btn-primary-bg);\n  color: var(--cfn-btn-primary-text);\n  box-shadow: 0 4px 12px var(--cfn-focus-ring);\n}\n\n.structure-form__footer-btn--danger {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-btn-danger-border);\n  color: var(--cfn-danger-text);\n}\n\n.structure-form__footer-btn--danger:not(:disabled):hover {\n  background: var(--cfn-btn-danger-hover-bg);\n}\n\n/* Spinner */\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.fa-spinner.fa-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Served-premises tick list in the premises box dialog */\n.structure-form__checkbox-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 4px 0;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.structure-form__checkbox-row input {\n  margin-top: 3px;\n  flex: 0 0 auto;\n}\n\n.structure-form__hint {\n  margin-left: 8px;\n  font-weight: 400;\n  opacity: 0.7;\n}\n\n/* Leaflet popup wrapper */\n.leaflet-popup-content-wrapper.structure-form-wrapper {\n  background: transparent;\n  padding: 0;\n  box-shadow: none;\n  border-radius: 12px;\n}\n\n.leaflet-popup-content-wrapper.structure-form-wrapper .leaflet-popup-content {\n  margin: 0;\n  width: auto !important;\n}\n\n.leaflet-popup-tip-container.structure-form-tip {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
